import { createRouter, createWebHashHistory } from 'vue-router'
import Dashboard from '../pages/public/dashboard.vue'
import UserDashboard from '../pages/private/user_dashboard.vue'
import Login from '../pages/login.vue'
import Register from '../pages/register.vue'
import Presentations from '../components/presentations.vue'
import Evaluations from '../pages/private/evaluation.vue'
import StudyPlan from '../pages/private/study_plan.vue'
import StudyPlanPublic from '../pages/public/study_plan_public.vue'
import InfoList from '../pages/private/infor_list.vue'
import InfoListPublic from '../pages/public/info_list.vue'
import Practice from '../pages/private/practice.vue'
import StudyGroups from '../pages/private/study_groups.vue'
import EvalQuest from '../pages/private/eval_quest.vue'
// import Infolisty from '../pages/infolisty_import.vue'
import CourseListPublic from '../pages/public/course_list_public.vue'
import CourseListPrivate from '../pages/private/course_list_private.vue'

const routes = [
  { 
    path: '/404', 
    component: Dashboard, 
    meta: {
      title : 'DashBoard',
      requiresAuth : false
    }
  }, {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      title : 'Dashboard',
      requiresAuth : false
    }
  }, { 
    path: '/register', 
    name: 'register',
    component: Register,
    meta: {
      title : 'Register',
      requiresAuth : false
    }
  }, {  
    path: '/login', 
    name: 'login',
    component: Login,
    meta: {
      title : 'Login',
      requiresAuth : false
    }
  }, {
    path: '/user_dashboard',
    name: 'user_dashboard',
    component: UserDashboard,
    meta: {
      title : 'User dashboard',
      requiresAuth : true
    }
  }, {
    path: '/presentations',
    name: 'presentations',
    component: Presentations,
    meta: {
      title : 'Prezentácie',
      requiresAuth : true
    }
  }, {
    path: '/evaluation',
    name: 'evaluation',
    component: Evaluations,
    meta: {
      title : 'Hodnotenie predmetov',
      requiresAuth : true
    }
  }, {
    path: '/study_plan',
    name: 'study_plan',
    component: StudyPlan,
    meta: {
      title : 'Študijný plán',
      requiresAuth : true
    }
  }, {
    path: '/stud_plan',
    name: 'stud_plan',
    component: StudyPlanPublic,
    meta: {
      title : 'Študijný plán',
      requiresAuth : false
    }
  }, {
    path: '/course_list_public',
    name: 'course_list_public',
    component: CourseListPublic,
    meta: {
      title : 'Ponuka kurzov',
      requiresAuth : false
    }
  }, {
    path: '/course_list',
    name: 'course_list',
    component: CourseListPrivate,
    meta: {
      title : 'Ponuka kurzov',
      requiresAuth : true
    }
  },  {
    path: '/info_list/:id',
    name: 'info_list',
    component: InfoListPublic,
    meta: {
      title : 'Informačný list',
      requiresAuth : false
    }
  }, {
    path: '/infor_list/:id',
    name: 'infor_list',
    component: InfoList,
    meta: {
      title : 'Informačný list',
      requiresAuth : true
    }
  }, {
    path: '/practice',
    name: 'practice',
    component: Practice,
    meta: {
      title : 'Prax',
      requiresAuth : true
    }
  }, {
    path: '/study_groups',
    name: 'study_groups',
    component: StudyGroups,
    meta: {
      title : 'Študijné skupiny',
      requiresAuth : true
    }
  }, {
    path: '/eval_quest/:predmet_id/:typ_dot/:obdobie',
    name: 'eval_quest',
    component: EvalQuest,
    meta: {
      title : 'Dotazník',
      requiresAuth : true
    }
  },    /*{
    path: '/infolisty',
    name: 'infolisty',
    component: Infolisty,
    meta: {
      title : 'Infolisty',
      requiresAuth : true
    }
  }, */
  { path: '/:catchAll(.*)', 
    component: Dashboard
  }
  
  // {
    //path: '/about',
    //name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL), //createWebHashHistory(), 
  routes
})

router.beforeEach((to, from, next) => {
  // console.log(to)
  var isLogged = false
  const requiresAuth = to.matched.some(record  => record.meta.requiresAuth)
  if (localStorage != null) {
    isLogged = localStorage.getItem('token') != null  
  }

  if (isLogged) {
    if (requiresAuth) {
      next()
    } else {
      next({ name: 'user_dashboard'} )
    }
  } else {
    if (requiresAuth) {
      next({ name: 'login'} )
    } else {
      next()
    }
  }

})

export default router
